var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    viewBox: "0 0 3333 3333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3021 0H313C141 0 0 141 0 313v2708c0 172 141 313 313 313h2708c172 0 313-141 313-313V313c0-172-141-313-313-313zm-286 1093c16-53 0-91-75-91h-249c-63 0-92 33-108 70 0 0-126 308-305 508-58 58-84 76-116 76-16 0-39-18-39-71v-492c0-63-18-91-70-91h-391c-40 0-63 29-63 57 0 60 90 74 99 242v366c0 80-14 95-46 95-84 0-289-309-411-664-24-69-48-97-111-97H601c-71 0-85 33-85 70 0 66 84 392 392 824 205 295 495 455 758 455 158 0 178-35 178-97v-223c0-71 15-85 65-85 37 0 100 18 248 161 169 169 196 244 291 244h249c71 0 107-35 86-106-22-70-103-171-210-291-58-68-145-142-171-179-37-47-26-68 0-111 0 0 303-427 334-571z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogo);
export default __webpack_public_path__ + "static/media/vk-logo.a275f51ef6bff70daff9e9ba2b240fdb.svg";
export { ForwardRef as ReactComponent };